import { TextLinkWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { RunFlowTaskInfo } from '~src/flow/models/RunFlowTaskInfo';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

import { getAndOpenLinkedTaskDetailsDialog } from './LinkedTaskDetailsDialog';

export function LinkedTaskWithCountCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function LinkedTaskWithCountCell(props: BodyCell.Props) {
        const row = props.row;
        const data = row.data as RunFlowTaskInfo;

        function handleLinkedTaskWithCountClick() {
          getAndOpenLinkedTaskDetailsDialog(data.linkedTaskId);
        }

        return(
          <TextLinkWidget
            testId={'FlowScheduleTypeCellTextLinkButton'}
            onClick={handleLinkedTaskWithCountClick}
            style={{fontWeight: 'normal'}}
          >
            {Messages.linkedTasksWithCount({TOTAL_COUNT_LOC: data.totalSteps.toString()})}
          </TextLinkWidget>
        );
      }
  );
}
